import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {bulkAssignRoleGrants} from 'src/openapi/admin/apis/BulkAssignRoleGrantsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';
import type {SuccessPayload} from 'src/typedef';

export const useAssignGrantsToRole = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        const payload: {success: true, error: false, data: string[]} = {
            success: true,
            error: false,
            data: [],
        };
        return Promise.resolve({type: '', payload});
    }, []);

    const saveDispatchAction = useCallback(async (
        addedGrants: string[],
        signal: AbortSignal,
        options?: {roleId: string, reason?: string},
    ) => {
        const {roleId, reason} = options ?? {};
        if (!roleId) {
            const payload: {success: false, error: true, data: Error} = {
                success: false,
                error: true,
                data: {message: 'Role ID is required'},
            };
            return Promise.resolve({type: '', payload});
        }

        const assignGrantsResponse = await apiDispatch(bulkAssignRoleGrants({
            reason,
            updateRoleGrant: {roleId, grantIds: addedGrants},
        }, {signal}));

        if (assignGrantsResponse.payload.success) {
            const payload: SuccessPayload<undefined> = {
                success: true,
                error: false,
                data: undefined,
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: assignGrantsResponse.payload});
        }
    }, [apiDispatch]);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
    });
};
